import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rightAligned", "children"];
/**
 * From https://git.hubteam.com/HubSpot/customer-data-table/blob/master/framework-data-table/static/js/contentRenderers/TruncateDiv.tsx
 * Copying customer-data-table's implementation as it fits perfectly to our needs.
 */

import styled from 'styled-components';
import { useCallback, useState } from 'react';
import { TooltipContent as FoundationsTooltipContent, Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoWrapDiv = styled.div.withConfig({
  displayName: "ListingLibTruncateDiv__NoWrapDiv"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:", ";width:", ";"], ({
  $rightAligned
}) => $rightAligned ? 'right' : null, ({
  $rightAligned
}) => $rightAligned ? '100%' : null);
export default function ListingLibTruncateDiv(_ref) {
  let {
      rightAligned,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(FoundationsTooltipContent, {
    children: children
  }), [children]);
  return /*#__PURE__*/_jsx(Tooltip, {
    Content: TooltipContent,
    maxInlineSize: "500px",
    disabled: !isTruncated,
    children: /*#__PURE__*/_jsx(NoWrapDiv, Object.assign({
      $rightAligned: rightAligned,
      onMouseEnter: handleMouseEnter
    }, rest, {
      children: children
    }))
  });
}